<app-user-info mode="view" [userId]="userId" [organisationId]="organisationId"></app-user-info>
